import React from 'react';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import createRoutes from './routes';
import reducers from './reducers/Foo';
import { TdsGlobalHeader, TdsGlobalFooter } from '@trv-tds/react';
import { ReactComponent as TrvLogoCssColorFullLarge } from '@trv-ebus/tds-icons/dist/assets/icons/logos/svg/trv-logo-css-color-full-large.svg';
import './styles/app.scss';
import { isCSSDomain } from './utility/methods';

let store = createStore(reducers);

function App() {
  const routes = createRoutes();
  const isCSS = isCSSDomain();

  return (
    <Provider store={store}>
      <TdsGlobalHeader>
        {isCSS && <TrvLogoCssColorFullLarge
          slot="logo"
          aria-hidden="true"
          className="tds-icon-trv-logo"
        />}
      </TdsGlobalHeader>
      <main>
        <h1>{process.env.REACT_APP_APPLICATION_TITLE}</h1>
        {routes}
      </main>

      <TdsGlobalFooter
        copyright="© 2026 The Travelers Indemnity Company. All rights reserved."
        sociallinks="true"
      >
        {isCSS && <TrvLogoCssColorFullLarge
          slot="logo"
          aria-hidden="true"
          className="tds-icon-trv-logo"
        />}

      </TdsGlobalFooter>
    </Provider>
  );
}

export default App;
